// LVB Prime panel role model.
//
// The Prime panel has NO city login. Every user who can sign in is one of:
//
//   Main Admin : u_type === 3 && is_subadmin === 0
//   Sub Admin  : u_type === 3 && is_subadmin === 1   (a delegate created by the main admin;
//                                                         insertStaff copies the creator's u_type,
//                                                         so a sub admin keeps u_type 3)
//   Staff      : u_type === 2
//
// Note: is_subadmin alone is not enough - it only disambiguates inside u_type 3.
// A staff user also carries is_subadmin = 0, so the u_type check must come first.

export const PRIME_ROLE = {
  MAIN_ADMIN: "MAIN_ADMIN",
  SUB_ADMIN: "SUB_ADMIN",
  STAFF: "STAFF"
};

export function getPrimeRole(loginUser) {
  if (!loginUser) return PRIME_ROLE.STAFF;
  const uType = parseInt(loginUser.u_type);
  const isSubAdmin = parseInt(loginUser.is_subadmin) === 1;
  if (uType === 3) return isSubAdmin ? PRIME_ROLE.SUB_ADMIN : PRIME_ROLE.MAIN_ADMIN;
  return PRIME_ROLE.STAFF;
}

export function getLoggedInUser() {
  try {
    return JSON.parse(localStorage.getItem("userData"));
  } catch (error) {
    return null;
  }
}

export function isMainAdmin(loginUser) {
  return getPrimeRole(loginUser) === PRIME_ROLE.MAIN_ADMIN;
}

export function isSubAdmin(loginUser) {
  return getPrimeRole(loginUser) === PRIME_ROLE.SUB_ADMIN;
}

export function isStaff(loginUser) {
  return getPrimeRole(loginUser) === PRIME_ROLE.STAFF;
}

// Staff are read-only everywhere in the stock module.
export function canViewStock(loginUser) {
  return getPrimeRole(loginUser) !== null;
}

// Move stock to a member: assign free, purchase, mark not eligible.
export function canAssignStock(loginUser) {
  const role = getPrimeRole(loginUser);
  return role === PRIME_ROLE.MAIN_ADMIN || role === PRIME_ROLE.SUB_ADMIN;
}

// Take a shipped item back out of a member's hands (returns qty to the pool).
export function canRevokeStock(loginUser) {
  return canAssignStock(loginUser);
}

// Top the pool up: stock-in and editing an existing stock-in line.
export function canAddStock(loginUser) {
  return canAssignStock(loginUser);
}

// Catalogue administration: create/edit products, toggle status, manage send types.
export function canManageCatalogue(loginUser) {
  return canAssignStock(loginUser);
}
